import { Component, OnInit, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { BalancesResponse } from '../../model/index';
import { BalancesConstants } from '../../utils/balances-constants';
import { BalancesLabels } from '../../i18n/balances-labels';

@Component({
    selector: 'modern-theme-balances-details-container',
    templateUrl: './balances-details-container.component.html'
})
export class BalancesDetailsContainerComponent implements OnInit {

    header: string = BalancesLabels.DETAIL_LABELS_HEADER;
    theme: string = 'standard';
    isLoading: boolean = true;
    balancesServiceErrorSub: any;
    fetchingBalancesDataSub: any;
    balancesResponseSub: any;
    balancesResponseErrorSub: any;
    SystemErrorMsg: string;
    isGroup: boolean = false;
    isMixedGroup: boolean = false;
    isCustodian: boolean = false;
    view: string;
    balancesResponse: BalancesResponse;
    BEMsg: string = '';
    errorMsg: boolean = true;

    constructor(
        private translationService: PershingTranslationService,
        private balancesService: BalancesService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        if (!!appSettings && !!appSettings.ibdConfigMap && !!appSettings.ibdConfigMap.themeType) {
            this.theme = appSettings.ibdConfigMap.themeType;
        }
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');

        // Generic, http error e.g. 500.
        this.balancesServiceErrorSub = this.balancesService.balancesServiceError$.subscribe(error => {
            if (error) {
                if (error.errorCode === BalancesConstants.BAD_REQUEST_ERROR.toString()) {
                    this.SystemErrorMsg = BalancesLabels.COMMON_ACCOUNT_LIMIT_ERROR;
                } else {
                    this.SystemErrorMsg = BalancesLabels.COMMON_SERV_UNAVAL_ERROR;
                }
                this.isLoading = false;
            }
        });

        // Got BalancesResponse but has 'errorCode' of non-zero.
        this.balancesResponseErrorSub = this.balancesService.balancesResponseError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
        });

        // loading
        this.fetchingBalancesDataSub = this.balancesService.fetchingBalancesData$.subscribe(fetching => {
            this.isLoading = !!fetching ? fetching : false;
        });

        this.balancesResponseSub = this.balancesService.balancesResponse$.subscribe(data => {
            if (!!data && !!data.response) {
                this.processBalancesData(data);
                this.balancesService.fetchingBalancesData$.next(false);
            } 
        });
    }

    processBalancesData(data: BalancesResponse) {
        if (!!data && !!data.response) {
            if (data.errorDescription === "SUCCESS") {
            this.balancesResponse = data;
            this.isGroup = this.balancesService.displayParams$.isGroup;
            this.isMixedGroup = this.balancesService.displayParams$.isMixedGroup;
            this.isCustodian = this.balancesService.displayParams$.isCustodian;
            this.resolveBalancesDetailsView();
            this.isLoading = false;
            this.errorMsg = true;
            }else  {
                this.errorMsg = false;
                this.isLoading = false;
            }
        }
    }

    resolveBalancesDetailsView() {
        if (this.isGroup && this.isMixedGroup) {
            // For the 'ALL' account and group contains both custodian and brokerage accounts.
            this.view = BalancesConstants.COMBINED_VIEW;
        } else if (!this.isMixedGroup && this.isCustodian) {
            // For either single or grouped accounts that are custodian only.
            this.view = BalancesConstants.CUSTODIAN_VIEW;
        } else if (!this.isMixedGroup && !this.isCustodian) {
            // For either single or grouped accounts that are brokerage only.
            this.view = BalancesConstants.BROKERAGE_VIEW;
        }
    }

    ngOnDestroy(): void {
        if (this.balancesResponseErrorSub) {
            this.balancesResponseErrorSub.unsubscribe();
        }
        if (this.balancesResponseSub) {
            this.balancesResponseSub.unsubscribe();
        }
        if (this.balancesServiceErrorSub) {
            this.balancesServiceErrorSub.unsubscribe();
        }
        if (this.fetchingBalancesDataSub) {
            this.fetchingBalancesDataSub.unsubscribe();
        }
    }
}
